import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatExpansionPanel, MatTab, MatTabGroup } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { clearFormControlValidators, CustomDirectiveConfig } from '@app/shared';
import { ResponseMessageTypes } from '@app/shared/enums';
import { CrudService, RxjsService, SnackbarService } from '@app/shared/services';
import { fileUrlDownload, formConfigs, isValidFilename, ModulesBasedApiSuffix, prepareGetRequestHttpParams, prepareRequiredHttpParams, setMinMaxFormValidator, setRequiredValidator } from '@app/shared/utils';
import { IApplicationResponse } from '@app/shared/utils/interfaces.utils';
import { RequisitionListCreationModel, StockCodeDescriptionModel } from '@modules/inventory/models/RequisitionListCreation.model';
import { InventoryModuleApiSuffixModels } from '@modules/inventory/shared';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { RequisitionCreationModalComponent } from './requisition-creation-modal.component';
import { StockInfoModalComponent } from './stock-info-modal.component';
import { StockOrderInterbranchModalComponent } from './stock-order-interbranch-modal.component';

@Component({
  selector: 'app-stock-order-add-edit',
  templateUrl: './stock-order-add-edit.component.html',
  styleUrls: ['./stock-order-add-edit.component.scss'],
})
export class StockOrderAddEditComponent implements OnInit {

  requisitionCreationForm: FormGroup;
  stockCodeDescriptionForm: FormGroup;
  selectedOptions: any = [];
  selectSupplierOptions: any = [];
  warehouseList = [];
  stockOrderTypeList = [];
  stockOrderNumbersList = [];
  stockCodeList = [];
  priorityList = [];
  filteredStockCodes = [];
  stockCodeAndDescriptionList = [];
  newStockOrderTypesStockCodeList = [];
  loggedUser: UserLogin;
  requisitionId: string;
  dropdownsAndData = [];
  selectedTabIndex = 0;
  breadCrumbTitle: any = '';
  fullListInterbranchRequisitionModel: any = {};
  filteredStockDescription: any = [];
  isStockCodeBlank: boolean = false;
  isStockDescriptionSelected: boolean = false;
  isStockOrderClear: boolean = false;
  stockCodeErrorMessage: any = '';
  showStockCodeError: boolean = false;
  isStockError: boolean = false;
  StockDescErrorMessage: any = '';
  showStockDescError: boolean = false;
  isStockDescError: boolean = false;
  isSubmit: boolean = false;
  rqnStatusName: any = '';
  isNewStock: boolean = true;
  isArrayEmpty = false;
  startTodayDate = new Date();
  decimalPattern = "/^\d+(\.\d{0,2})?$/";
  @ViewChild('matExpansionPanel', { static: false }) matExpansionPanelElement: MatExpansionPanel;
  @ViewChildren('matTab') matTab: MatTab;
  @ViewChild('stockOrderTypeRef', { static: false }) stockOrderTypeRef: ElementRef<HTMLSelectElement>;
  @ViewChild('priorityTypeRef', { static: false }) priorityTypeRef: ElementRef<HTMLSelectElement>;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  isLoading: boolean;
  minDate: Date = new Date();
  numberConfig = new CustomDirectiveConfig({ isANumberOnly: true });
  decimalConfig = new CustomDirectiveConfig({ isADecimalOnly: true });
  isADecimalWithConfig = new CustomDirectiveConfig({ isADecimalWithConfig: { trailingDotDigitsCount: 2 } });
  storageLocationDropDown: any;
  suppliersDropDown: any = []
  public formData = new FormData();
  fileList: File[] = [];
  listOfFiles: any[] = [];
  @ViewChild('fileInput', null) myFileInputField: ElementRef;
  @ViewChild('requiredQtyDiv', null) requiredQtyDiv: ElementRef;
  maxFilesUpload: Number = 5;
  supplierDocuments: any = [];
  fromValue: Number = 0;
  toValue: Number = 0;
  requestType: string = '';
  userId: string = '';
  referenceId: string = '';
  approvalStatusName: any
  statusList: any = [];
  fullListSubTotal: number = 0;
  requestListSubTotal: number = 0;
  rqnStatusError: boolean;
  isStockChanged: boolean = false;
  isToggle = true;
  isDeletePopup: boolean = false;
  deleteIndex;
  stockId;
  stockOrderIds;
  control;
  isAdd: boolean = false;
  isRepairStock: boolean = true;
  loggedInUserData;
  enableStockOrder: boolean = true;
  interBranchDetailsArr: any = [];
  primengTableConfigProperties;
  isSubmitDoc: boolean = false;
  mainStockOrderList = [];
  isOnceOff: boolean = false;
  stockCodes = [];
  contractPriceData = [];
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private crudService: CrudService,
    private httpService: CrudService,
    private snackbarService: SnackbarService,
    private rxjsService: RxjsService,
    private store: Store<AppState>,
    private dialog: MatDialog, private changeDetectorRef: ChangeDetectorRef
  ) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
    this.requisitionId = this.activatedRoute.snapshot.queryParams.requisitionId;
    this.requestType = this.activatedRoute.snapshot.queryParams.type;
    this.userId = this.activatedRoute.snapshot.queryParams.userId;
    this.referenceId = this.activatedRoute.snapshot.queryParams.referenceId;
    let title = this.requisitionId ? 'Update ' : 'Create ';
    this.primengTableConfigProperties = {
      tableCaption: title + 'Requisition',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '/inventory/dashboard' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: title + 'Requisition',
            enableBreadCrumb: true,
            enableAction: true
          },
          {
            caption: title + 'Requisition',
            enableBreadCrumb: true,
            enableAction: true
          },
          {
            caption: title + 'Requisition',
            enableBreadCrumb: true,
            enableAction: true
          }
        ]
      }
    }

    this.setBreadcrum();
  }
  setBreadcrum() {
    this.primengTableConfigProperties.breadCrumbItems = [];
    this.primengTableConfigProperties.breadCrumbItems.push({ displayName: 'Inventory Management', relativeRouterUrl: '/inventory/dashboard' });
    if (this.requestType != 'inventory-task-list')
      this.primengTableConfigProperties.breadCrumbItems.push({ displayName: 'Ordering', relativeRouterUrl: '' });

    if (this.requestType != 'inventory-task-list')
      this.primengTableConfigProperties.breadCrumbItems.push({ displayName: 'Requisition', relativeRouterUrl: '/inventory/requisitions/stock-orders' });

    if (this.requestType == 'inventory-task-list')
      this.primengTableConfigProperties.breadCrumbItems.push({ displayName: 'Inventory Task List', relativeRouterUrl: '/my-tasks/inventory-task-list' });

    if (this.requisitionId && this.requestType != 'inventory-task-list') {
      this.primengTableConfigProperties.breadCrumbItems.push({
        displayName: 'View Requisition', relativeRouterUrl: '/inventory/requisitions/stock-orders/requisition-view', queryParams: {
          requisitionId: this.requisitionId,
          userId: this.loggedUser.userId,
          type: 'requisition-list',
          toValue: this.toValue ? this.toValue : 0,
          referenceId: this.referenceId
        }
      });
    }
    let title = this.requisitionId ? 'Update ' : 'Create ';
    this.primengTableConfigProperties.breadCrumbItems.push({ displayName: title + 'Requisition', relativeRouterUrl: '' });

  }
  ngOnInit() {
    this.rxjsService.setFormChangeDetectionProperty(true);
    this.createRequisitionCRUDForm();
    this.createStockCodeDescriptionForm();
    this.getSuppliersDropdown()
    this.getStatusDropDown();
    //this.getRequistionCreation(); handled in backend for checking total range for each role based user
    if (this.requisitionId) {
      this.breadCrumbTitle = 'Update';
      this.dropdownsAndData = [
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.UX_WAREHOUSE, prepareRequiredHttpParams({
            userId: this.loggedUser.userId
          })),
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.STOCK_ORDER_TYPES),
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.UX_PRIORITY),
        this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.REQUISITION_DETAILS, null, true, prepareRequiredHttpParams({ requisitionId: this.requisitionId, UserId: this.loggedUser.userId }))
      ];
      this.requisitionCreationForm.get('warehouseId').disable({ emitEvent: false });
      this.requisitionCreationForm.get('requisitionDate').disable({ emitEvent: false });
      this.requisitionCreationForm.get('stockOrderTypeId').disable({ emitEvent: false });
    }
    else {
      this.breadCrumbTitle = 'Create';
      this.dropdownsAndData = [
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.UX_WAREHOUSE, prepareRequiredHttpParams({
            userId: this.loggedUser.userId
          })),
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.STOCK_ORDER_TYPES),
        this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY,
          InventoryModuleApiSuffixModels.UX_PRIORITY)
      ];
      this.requisitionCreationForm.get('requisitionDate').setValue(new Date());
    }
    this.loadActionTypes(this.dropdownsAndData);
    // To catch changes from interbranch pop up submit
    this.rxjsService.getRequisitionData().subscribe(data => {
    });
    this.stockCodeDescriptionForm.get('stockId').disable();
    this.stockCodeDescriptionForm.get('stockDescription').disable();
    this.stockCodeDescriptionForm.get('requestedOty').disable();
    this.valueChange();
  }
  createRequisitionCRUDForm(reqCreationListModel?: RequisitionListCreationModel) {
    let requisitionCreationModel = new RequisitionListCreationModel(reqCreationListModel);
    this.requisitionCreationForm = this.formBuilder.group({});
    let stockItemsFormArray = this.formBuilder.array([]); // [], Validators.required
    Object.keys(requisitionCreationModel).forEach((key) => {
      if (typeof requisitionCreationModel[key] !== 'object') {
        this.requisitionCreationForm.addControl(key,
          new FormControl(requisitionCreationModel[key]));
      } else {
        this.requisitionCreationForm.addControl(key, stockItemsFormArray);
      }
    });
    this.requisitionCreationForm = setMinMaxFormValidator(this.requisitionCreationForm, [{ name: "Motivation", maxlength: formConfigs?.maxLengthTwoHundred }]);
    this.requisitionCreationForm = setRequiredValidator(this.requisitionCreationForm, ['warehouseId', 'requisitionDate', 'stockOrderTypeId', 'priorityId', 'LocationId', 'Motivation', 'supplierId']);
    this.isNewStock = false;
  }
  valueChange() {
    this.requisitionCreationForm.get('warehouseId').valueChanges.pipe(distinctUntilChanged()).subscribe(data => {
      this.stockCodeAndDescriptionList = [];
      if (data) {
        this.stockOrderNumbersList = [];
        this.getStockOrderNumbersByWarehouseId(data);
        this.getStorageLocationByWarehouseId(data);
      } else {
        this.stockOrderNumbersList = [];
        this.storageLocationDropDown = [];
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
    this.requisitionCreationForm.get('stockOrderTypeId').valueChanges.pipe(distinctUntilChanged()).subscribe(data => {
      this.isArrayEmpty = false;
      this.isRepairStock = true;
      this.isOnceOff = this.stockOrderTypeList.find(x => x.id == this.requisitionCreationForm.get('stockOrderTypeId').value.toLowerCase()).displayName.toLowerCase() == 'once off' ? true : false;
      this.requisitionCreationForm.get('stockOrderIds').reset();
      this.getStockOrderNumbersByWarehouseId(this.requisitionCreationForm.get('warehouseId').value);
      if (data) {
        this.stockCodeDescriptionForm.get('stockId').enable();
        this.stockCodeDescriptionForm.get('stockDescription').enable();
        this.stockCodeDescriptionForm.get('requestedOty').enable();
      }
      if (this.stockOrderTypeList.find(x => x.id == data?.toLowerCase())?.displayName?.toLowerCase() === 'new stock') {

        this.enableStockOrder = false;
        this.stockCodeDescriptionForm.get('stockId').enable();
        this.stockCodeDescriptionForm.get('stockDescription').enable();
        this.stockCodeDescriptionForm.get('requestedOty').enable();
        this.requisitionCreationForm.get('stockOrderIds').disable();
        this.requisitionCreationForm.get('stockOrderIds').setValue('');
        //this.requisitionCreationForm = clearFormControlValidators(this.requisitionCreationForm, ["stockOrderIds"]);
        this.isNewStock = false;
        let priorityData = this.priorityList.find(priority => priority.displayName.toLowerCase() === 'standard');
        this.requisitionCreationForm.get('priorityId').setValue(priorityData.id);
        if (!this.requisitionCreationForm.get('stockOrderIds').value) {
          this.stockItemsFormArray.clear(); // To clear form array table
        }
      }
      else if (this.stockOrderTypeList.find(x => x.id == data?.toLowerCase())?.displayName?.toLowerCase() === 'job specific' || this.stockOrderTypeList.find(x => x.id == data?.toLowerCase())?.displayName?.toLowerCase() === 'once off') {
        this.enableStockOrder = true;
        this.requisitionCreationForm.get('stockOrderIds').enable({ emitEvent: false });
        this.isNewStock = true;
        // Make stock order number required
        //  this.requisitionCreationForm.get('stockOrderIds').setValidators([Validators.required]);
        let priorityData = this.priorityList.find(priority => priority.displayName.toLowerCase() === 'medium');
        this.requisitionCreationForm.get('priorityId').setValue(priorityData.id);
        if (!this.requisitionCreationForm.get('stockOrderIds').value) {
          this.stockItemsFormArray.clear(); // To clear form array table
        }
      }
      else if (this.stockOrderTypeList.find(x => x.id == data?.toLowerCase())?.displayName?.toLowerCase() === 'urgent') {
        this.enableStockOrder = true;
        this.requisitionCreationForm.get('stockOrderIds').enable({ emitEvent: false });
        this.isNewStock = true;
        let priorityData = this.priorityList.find(priority => priority.displayName.toLowerCase() === 'high');
        this.requisitionCreationForm.get('priorityId').setValue(priorityData.id);
        if (!this.requisitionCreationForm.get('stockOrderIds').value) {
          this.stockItemsFormArray.clear(); // To clear form array table
        }
      }
      else if (this.stockOrderTypeList.find(x => x.id == data?.toLowerCase())?.displayName?.toLowerCase() === 'repair stock') {
        this.stockCodeDescriptionForm.get('stockId').enable();
        this.stockCodeDescriptionForm.get('stockDescription').enable();
        this.stockCodeDescriptionForm.get('requestedOty').enable();
        this.enableStockOrder = true;
        this.requisitionCreationForm.get('stockOrderIds').setValue('');
        this.requisitionCreationForm.get('stockOrderIds').disable();
        //  this.requisitionCreationForm.get('stockOrderIds').setValidators([Validators.required]);
        this.isRepairStock = false;
      }
      else {
        this.enableStockOrder = true;
        // this.newStockOrderTypesStockCodeList = []; // For stock order types other than new stock we will never et new stock codes for the selected warehouse so we should make it empty
        if (!this.requisitionCreationForm.get('stockOrderIds').value) {
          this.stockItemsFormArray.clear(); // To clear form array table
        }
        this.requisitionCreationForm.get('stockOrderIds').enable({ emitEvent: false });
        this.isNewStock = true;
        // this.requisitionCreationForm.get('stockOrderIds').setValidators([Validators.required]);
      }
    });

    // To catch changes inside stock code
    this.stockCodeDescriptionForm.get('stockId').valueChanges.pipe(debounceTime(300), distinctUntilChanged(),
      switchMap(searchText => {
        if (this.stockCodeDescriptionForm.get('stockId').value?.displayName)
          searchText = this.stockCodeDescriptionForm.get('stockId').value?.displayName;

        this.isStockDescError = false
        this.StockDescErrorMessage = '';
        this.showStockDescError = false;

        if (this.isStockError == false) {
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
        }
        else {
          this.isStockError = false;
        }
        if (searchText != null) {
          searchText = searchText?.trim();
          if (this.isStockCodeBlank == false) {
            this.stockCodeDescriptionForm.controls.stockDescription.patchValue(null);
            this.stockCodeDescriptionForm.controls.requestedOty.patchValue(null);
          }
          else {
            this.isStockCodeBlank = false;
          }
          if (!searchText) {
            if (searchText === '') {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
            }
            else {
              this.stockCodeErrorMessage = 'Stock code is not available in the system';
              this.showStockCodeError = true;
              this.isStockError = true;
            }
            this.rxjsService.setGlobalLoaderProperty(false);
            // this.snackbarService.openSnackbar('Stock code is not available in the system', ResponseMessageTypes.ERROR);
            return this.filteredStockCodes = [];
          } else {
            let flag = true; let params;
            flag = this.stockOrderTypeList.find(x => x.id == this.requisitionCreationForm.get('stockOrderTypeId').value.toLowerCase()).displayName.toLowerCase() === 'repair stock' ? false : true;
            this.isOnceOff = this.stockOrderTypeList.find(x => x.id == this.requisitionCreationForm.get('stockOrderTypeId').value.toLowerCase()).displayName.toLowerCase() == 'once off' ? true : false;
            if (!flag) {
              params = { searchText, isAll: false, materialtype: flag ? 'Y' : null, IsRequisition: true, IsRepairCode: true, IsOnceOff: this.isOnceOff };
            }
            else
              params = { searchText, isAll: false, warehouseId: this.requisitionCreationForm.controls['warehouseId'].value, materialtype: flag ? 'Y' : null, IsRequisition: true, IsOnceOff: this.isOnceOff };
            this.rxjsService.setGlobalLoaderProperty(false);
            return this.crudService.get(
              ModulesBasedApiSuffix.INVENTORY,
              InventoryModuleApiSuffixModels.UX_ITEM_SEARCH_BY_CODE, null, true,
              prepareGetRequestHttpParams(null, null, params))
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        else {
          this.rxjsService.setGlobalLoaderProperty(false);
          return this.filteredStockCodes = [];
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources.length > 0) {
          this.filteredStockCodes = [];
          response.resources.forEach(element => {
            if (element.displayName == null && element.message) {
              this.snackbarService.openSnackbar(element.message, ResponseMessageTypes.ERROR);
              return;
            }
            else {
              this.filteredStockCodes.push(element);
            }
          });
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        else {
          this.filteredStockCodes = [];
          this.stockCodeErrorMessage = 'Stock code is not available in the system';
          this.showStockCodeError = true;
          this.isStockError = true;
          this.rxjsService.setGlobalLoaderProperty(false);
          // this.snackbarService.openSnackbar('Stock code is not available in the system', ResponseMessageTypes.ERROR);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });

    // To catch changes inside stock description
    this.stockCodeDescriptionForm.get('stockDescription').valueChanges.pipe(debounceTime(300), distinctUntilChanged(),
      switchMap(searchText => {
        if ((searchText != null)) {
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;

          if (this.isStockDescError == false) {
            this.StockDescErrorMessage = '';
            this.showStockDescError = false;
          }
          else {
            this.showStockDescError = false;
          }
          if (this.isStockDescriptionSelected == false) {
            this.stockCodeDescriptionForm.controls.stockId.patchValue(null);
            this.stockCodeDescriptionForm.controls.requestedOty.patchValue(null);
          }
          else {
            this.isStockDescriptionSelected = false;
          }
          if (!searchText) {
            if (searchText === '') {
              this.StockDescErrorMessage = '';
              this.showStockDescError = false;
              this.isStockDescError = false;
            }
            this.rxjsService.setGlobalLoaderProperty(false);
            return this.filteredStockDescription = [];
          } else {
            this.isOnceOff = this.stockOrderTypeList.find(x => x.id == this.requisitionCreationForm.get('stockOrderTypeId').value.toLowerCase()).displayName.toLowerCase() == 'once off' ? true : false;
            return this.crudService.get(
              ModulesBasedApiSuffix.INVENTORY,
              InventoryModuleApiSuffixModels.UX_ITEM_SEARCH_BY_NAME, null, true,
              prepareGetRequestHttpParams(null, null, { searchText, isAll: false, warehouseId: this.requisitionCreationForm.controls['warehouseId'].value, materialtype: 'Y', IsOnceOff: this.isOnceOff }))
          }
        } else {
          this.rxjsService.setGlobalLoaderProperty(false);
          return this.filteredStockDescription = [];
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources.length > 0) {
          this.filteredStockDescription = response.resources;
          this.isStockDescriptionSelected = false;
          this.StockDescErrorMessage = '';
          this.showStockDescError = false;
          this.isStockDescError = false;
          this.rxjsService.setGlobalLoaderProperty(false);
        } else {
          this.filteredStockDescription = [];
          this.isStockDescriptionSelected = false;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });

    this.requisitionCreationForm.get('rqnStatusId').valueChanges.pipe(distinctUntilChanged()).subscribe(id => {

      let obj = this.statusList.filter(data => {
        if (data.id == id) {
          return true
        }
      });
      //  this.requisitionCreationForm.get('stockOrderIds').clearValidators();
      //  this.requisitionCreationForm = clearFormControlValidators(this.requisitionCreationForm, ['stockOrderIds']);
      if (obj.length > 0) {
        this.approvalStatusName = obj[0].displayName;
        if (obj[0].displayName == 'Cancelled' || obj[0].displayName == 'Rejected') {
          this.requisitionReasonsMsg = true;
          // this.requisitionCreationForm = setRequiredValidator(this.requisitionCreationForm, [ "reason"]);
        }
        if (obj[0].displayName == 'Approved') {
          this.rqnStatusError = false;
          this.requisitionReasonsMsg = false;
          this.requisitionCreationForm.get('reason').setErrors(null);
        }
        else if (obj[0].displayName != 'Cancelled' && obj[0].displayName != 'Rejected') {
          this.requisitionCreationForm.get('reason').setErrors(null);
          this.requisitionReasonsMsg = false;
        }
      }
      //  this.requisitionCreationForm = clearFormControlValidators(this.requisitionCreationForm, ['stockOrderIds']);
    });
  }
  discrepancyReason() {
    this.isStockChanged = true;
  }
  ngAfterViewInit() {
    if (!this.requisitionId) {
      this.tabGroup._tabs['_results'][1].disabled = false;
      this.tabGroup._tabs['_results'][2].disabled = false;
    }
  }
  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }
  onTabClicked(tabData) {
    this.selectedTabIndex = tabData.index;
    if (this.selectedTabIndex != 0) {
      this.requisitionCreationForm.get('warehouseId').disable({ emitEvent: false });
      this.requisitionCreationForm.get('requisitionDate').disable({ emitEvent: false });
      this.requisitionCreationForm.get('stockOrderTypeId').disable({ emitEvent: false });
      this.requisitionCreationForm.get('priorityId').disable({ emitEvent: false });
    } else { // 0
      if (this.requisitionId) {
        this.requisitionCreationForm.get('warehouseId').disable({ emitEvent: false });
        this.requisitionCreationForm.get('requisitionDate').disable({ emitEvent: false });
        this.requisitionCreationForm.get('stockOrderTypeId').disable({ emitEvent: false });
        this.requisitionCreationForm.get('stockOrderIds').enable({ emitEvent: false });
        this.requisitionCreationForm.get('priorityId').enable({ emitEvent: false });
      } else {
        this.requisitionCreationForm.get('warehouseId').enable({ emitEvent: false });
        this.requisitionCreationForm.get('requisitionDate').enable({ emitEvent: false });
        this.requisitionCreationForm.get('stockOrderTypeId').enable({ emitEvent: false });
        this.requisitionCreationForm.get('stockOrderIds').enable({ emitEvent: false });
        this.requisitionCreationForm.get('priorityId').enable({ emitEvent: false });
      }
    }
    this.setBreadcrum();
  }

  loadActionTypes(dropdownsAndData) {
    forkJoin(dropdownsAndData).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.warehouseList = resp.resources;
              this.requisitionCreationForm.get('warehouseId').setValue(this.loggedUser.warehouseId);
              break;
            case 1:
              this.stockOrderTypeList = resp.resources;
              //this.requisitionCreationForm.get('stockOrderTypeId').setValue(this.stockOrderTypeList[0].id);
              break;
            case 2:
              this.priorityList = resp.resources;
              break;
            case 3:
              this.requisitionCreationForm.get('warehouseId').setValue(this.loggedUser.warehouseId);
              this.selectedOptions = [];
              this.isRepairStock = resp.resources.orderType?.toLowerCase() == "repair stock" ? false : true;
              this.stockItemsFormArray.clear();
              this.fullListInterbranchRequisitionModel = {};
              resp?.resources?.requisitionRequests?.forEach(val => {

                val.contractCost = (val.contractCost) ? val.contractCost.toFixed(2) : '0.00';
                val.costPrice = (val.costPrice) ? val.costPrice.toFixed(2) : '0.00';
                val.subTotal = (val.subTotal) ? val.subTotal.toFixed(2) : '0.00';
                return val;
              });
              this.fullListInterbranchRequisitionModel = resp.resources;
              // this.requisitionCreationForm.patchValue(resp.resources);
              if (resp.resources?.supplierDocuments.length > 0) {
                resp.resources?.supplierDocuments.forEach(element => {
                  this.listOfFiles.push({ id: element.requisitionSupplierDocumentId, name: element.docName, path: element.path })
                });
              }
              this.requisitionCreationForm.get('stockOrderTypeId').setValue(resp.resources?.orderTypeId);
              if (resp.resources.rqnStatusName == "New" || resp.resources.rqnStatusName == "Save as Draft") {
                //  this.requisitionCreationForm = clearFormControlValidators(this.requisitionCreationForm, ['stockOrderIds']);
              }

              this.requisitionCreationForm.get('supplierId').patchValue(resp.resources.supplierId);

              this.requisitionCreationForm.get('warehouseId').setValue(resp.resources.warehouseId);
              this.requisitionCreationForm.get('priorityId').setValue(resp.resources.priorityId);
              this.requisitionCreationForm.get('Motivation').setValue(resp.resources.motivation);
              this.requisitionCreationForm.get('rqnStatusId').patchValue(resp.resources.rqnStatusId);
              this.requisitionCreationForm.get('requisitionId').setValue(this.fullListInterbranchRequisitionModel['requisitionId']);
              this.requisitionCreationForm.get('warehouseId').setValue(this.fullListInterbranchRequisitionModel['warehouseId']);
              this.supplierDocuments = this.fullListInterbranchRequisitionModel['supplierDocuments']
              this.listOfFiles = [];
              if (this.fullListInterbranchRequisitionModel['supplierDocuments'].length > 0) {
                this.fullListInterbranchRequisitionModel['supplierDocuments'].forEach(element => {
                  this.listOfFiles.push({ id: element.requisitionSupplierDocumentId, name: element.docName, path: element.path })
                });
              }
              this.requisitionCreationForm.get('requisitionDate').setValue(new Date(this.fullListInterbranchRequisitionModel['requisitionDate']));
              if (this.fullListInterbranchRequisitionModel['orderType'].toLowerCase() == 'new stock') {
                this.requisitionCreationForm.get('stockOrderIds').setValue(null);
                this.requisitionCreationForm.get('stockOrderIds').disable();
                this.isNewStock = false;
              }
              this.fullListInterbranchRequisitionModel['items'] = resp.resources.items;
              if (resp.resources.items.length > 0) {
                this.fullListSubTotal = 0;
                resp.resources.items.forEach(datas => {
                  this.fullListSubTotal += datas.subTotal;
                });
              }
              if (resp.resources.requisitionRequests.length > 0) {
                this.requestListSubTotal = 0;
                resp.resources.requisitionRequests.forEach(requests => {
                  this.requestListSubTotal += requests.subTotal;
                });
              }
              this.rqnStatusName = resp.resources.rqnStatusName;
              let selectedOptionsArr = [];
              selectedOptionsArr = resp.resources.stockOrderNumbers?.split(',');
              selectedOptionsArr?.forEach(element => {
                let filteredOption = this.stockOrderNumbersList.filter(x => x.id == element);
                if (filteredOption?.length > 0)
                  this.selectedOptions.push(filteredOption);
              });
              if (this.selectedOptions?.length > 0)
                this.requisitionCreationForm.get('stockOrderIds').setValue(this.selectedOptions);

              // if (this.fullListInterbranchRequisitionModel['stockOrderIds'] && this.fullListInterbranchRequisitionModel['stockOrderIds'].indexOf(',') > 0) {
              //   this.requisitionCreationForm.get('stockOrderIds').setValue(this.selectedOptions);

              // } else if (this.fullListInterbranchRequisitionModel['stockOrderIds']) {

              //  // this.selectedOptions = [this.fullListInterbranchRequisitionModel['stockOrderIds']];
              // }
              if (this.fullListInterbranchRequisitionModel['supplierId'] && this.fullListInterbranchRequisitionModel['supplierId'].indexOf(',') > 0) {
                this.selectSupplierOptions = this.fullListInterbranchRequisitionModel['supplierId'].split(',');
              } else if (this.fullListInterbranchRequisitionModel['supplierId']) {
                this.selectSupplierOptions = this.fullListInterbranchRequisitionModel['supplierId'];
              }

              this.setInterbranch(this.fullListInterbranchRequisitionModel['interBranchTransfers']);
              this.createRequisitionDataTable(this.fullListInterbranchRequisitionModel['items'], true);
              if (Object.keys(this.fullListInterbranchRequisitionModel['interBranchTransfers']).length > 0) {
                this.tabGroup._tabs['_results'][1].disabled = false;
              } else {
                this.tabGroup._tabs['_results'][1].disabled = false;
              }
              if (Object.keys(this.fullListInterbranchRequisitionModel['requisitionRequests']).length > 0) {
                this.tabGroup._tabs['_results'][2].disabled = false;
              } else {
                this.tabGroup._tabs['_results'][2].disabled = false;
              }
              this.requisitionCreationForm.get('reason').patchValue(null);
              this.requisitionCreationForm.get('supplierId').patchValue(resp.resources.supplierId);

              this.requisitionCreationForm.get('warehouseId').patchValue(resp.resources.warehouseId);
              this.requisitionCreationForm.get('requisitionDate').patchValue(new Date(resp.resources.requisitionDate));
              this.requisitionCreationForm.get('priorityId').patchValue(resp.resources.priorityId);
              this.requisitionCreationForm.get('LocationId').patchValue(resp.resources.locationId);
              this.requisitionCreationForm.get('Motivation').patchValue(resp.resources.motivation);
              break;
          }
        }
      })
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }
  setInterbranch(interBranchTransfers) {
    let interBranchTransfersFinal;
    //interBranchTransfers
    // this.fullListInterbranchRequisitionModel['interBranchTransfers'] = interBranchTransfersFinal;
  }
  onStatucCodeSelected(value, type) {
    if (value?.displayName)
      value = value?.displayName;

    let stockItemData;
    if (value && type === 'stockCode') {
      stockItemData = this.stockItemsFormArray.value.find(stock => stock.stockCode === value);
      if (!stockItemData) {
        this.isStockDescriptionSelected = true;
        this.httpService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.ITEM, this.filteredStockCodes.find(x => x.displayName === value).id).subscribe((response) => {
          if (response.statusCode == 200) {
            this.stockCodeDescriptionForm.controls.stockDescription.patchValue(response.resources.itemName);
          }
        })
      }
      else {
        this.stockCodeDescriptionForm.controls.stockDescription.patchValue(null);
        this.stockCodeDescriptionForm.controls.stockId.patchValue(null);
        this.isStockError = true;
        this.stockCodeErrorMessage = 'Stock code is already present';
        this.showStockCodeError = true;
      }
    } else if (value && type === 'stockDescription') {
      stockItemData = this.stockItemsFormArray.value.find(stock => stock.stockDescription === value);
      if (!stockItemData) {
        this.isStockCodeBlank = (this.stockCodeDescriptionForm.get('stockId').value == null || this.stockCodeDescriptionForm.get('stockId').value == '') ? true : false;
        this.httpService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.ITEM, this.filteredStockDescription.find(x => x.displayName === value).id).subscribe((response) => {
          if (response.statusCode == 200) {
            this.filteredStockCodes = [{
              id: response.resources.itemId,
              displayName: response.resources.itemCode
            }];
            this.stockCodeDescriptionForm.controls.stockId.patchValue(response.resources.itemCode);
          }
        })
      }
      else {
        this.stockCodeDescriptionForm.controls.stockDescription.patchValue(null);
        this.stockCodeDescriptionForm.controls.stockId.patchValue(null);
        this.isStockDescError = true;
        this.StockDescErrorMessage = 'Stock Description is already present';
        this.showStockDescError = true;
      }
    }
  }
  // getRequistionCreation(){
  //   this.crudService.get(
  //     ModulesBasedApiSuffix.INVENTORY,
  //     InventoryModuleApiSuffixModels.REQUISITION_CREATION_VALIDATION,
  //     this.loggedUser.userId,
  //     false,
  //     null
  //   ).subscribe((response:any) => {
  //     this.fromValue = response.resources.fromValue;
  //     this.toValue = response.resources.toValue;
  //   });
  // }
  getStockOrderNumbersByWarehouseId(warehouseId) {
    let data = {};
    if (Object.keys(this.fullListInterbranchRequisitionModel).length > 0) {
      data['WarehouseId'] = warehouseId ? warehouseId : this.fullListInterbranchRequisitionModel.warehouseId;
      data['userId'] = this.loggedUser.userId;
      data['StockOrderTypeId'] = this.requisitionCreationForm.get('stockOrderTypeId').value;
      data['requisitionId'] = this.requisitionCreationForm.get('requisitionId').value;
    } else {
      data['WarehouseId'] = warehouseId ? warehouseId : this.fullListInterbranchRequisitionModel.warehouseId;
      data['userId'] = this.loggedUser.userId;
      data['StockOrderTypeId'] = this.requisitionCreationForm.get('stockOrderTypeId').value;
      data['requisitionId'] = this.requisitionCreationForm.get('requisitionId').value;
    }
    if (data['WarehouseId']) {
      this.crudService.get(
        ModulesBasedApiSuffix.INVENTORY,
        InventoryModuleApiSuffixModels.UX_STOCK_ORDERS,
        undefined,
        false,
        prepareRequiredHttpParams(data)
      ).subscribe(response => {
        let respObj = response.resources;
        if (response.resources && response.resources.length > 0 && Object.keys(respObj).length > 0) {
          this.stockOrderNumbersList = response.resources;
          if (this.requisitionId) {
            let stockOrderIds = this.fullListInterbranchRequisitionModel?.stockOrderIds?.split(',');
            let filterObj;
            if (stockOrderIds?.length > 0)
              filterObj = this.stockOrderNumbersList.filter(item => stockOrderIds.includes(item.id));

            if (filterObj?.length > 0)
              this.requisitionCreationForm.get('stockOrderIds').setValue(filterObj);
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        } else {
          this.stockOrderNumbersList = [];
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    }

  }

  getStorageLocationByWarehouseId(warehouseId) {
    let data = {};
    data['WarehouseId'] = warehouseId ? warehouseId : this.fullListInterbranchRequisitionModel.warehouseId;
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_LOCATION, undefined,
      false, prepareRequiredHttpParams(data))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.storageLocationDropDown = [];
          this.storageLocationDropDown = response.resources;
          if (this.fullListInterbranchRequisitionModel['locationId'] && this.fullListInterbranchRequisitionModel['locationId'] != "00000000-0000-0000-0000-000000000000") {
            this.requisitionCreationForm.get('LocationId').setValue(this.fullListInterbranchRequisitionModel['locationId']);
          } else {
            if (this.storageLocationDropDown.length > 0) {
              let filteredObj = this.storageLocationDropDown.filter((item: any) => {
                if (JSON.stringify(item).includes('Main')) {
                  return item;
                }
              });
              this.requisitionCreationForm.get('LocationId').setValue(filteredObj?.length > 0 ? filteredObj[0].id : '');
            }
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  getSuppliersDropdown() {
    this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_SUPPLIERS)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          let temp = [];
          response.resources.forEach((element) => {
            temp.push({ label: element.displayName, value: element.id });
          })
          this.suppliersDropDown = temp;

          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }

  getStatusDropDown() {
    this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_RQNSTATUS)
      .subscribe((response: IApplicationResponse) => {
        let status = response.resources;
        if (status.length > 0) {
          this.statusList = status.filter(x => x.displayName === 'Approved' || x.displayName === 'Cancelled' ||
            x.displayName === 'Pending' || x.displayName === 'Rejected');
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  stockInfoModal(interBranchStockDetails) {

    const dialogReff = this.dialog.open(StockInfoModalComponent, {
      width: '600px',
      data: {
        interBranchStockDetails: interBranchStockDetails
      },
      disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {
      if (result) return;
      this.rxjsService.setDialogOpenProperty(false);
    });
  }

  createStockCodeDescriptionForm(stockCodeDescriptionModel?: StockCodeDescriptionModel) {
    let stockCodeModel = new StockCodeDescriptionModel(stockCodeDescriptionModel);
    this.stockCodeDescriptionForm = this.formBuilder.group({});
    Object.keys(stockCodeModel).forEach((key) => {
      if (typeof stockCodeModel[key] !== 'object') {
        this.stockCodeDescriptionForm.addControl(key, new FormControl(stockCodeModel[key]));
      }
    });
  }


  getStockCodesByStockNumber(stockNumbers) {

    let existingValue = stockNumbers?.value;
    let selectedValue = stockNumbers?.itemValue;
    let stockNumbersArr = [];
    existingValue.forEach(element => {
      stockNumbersArr.push(element?.id);
    });

    if (stockNumbersArr.length > 0) {
      let params; params = { Ids: stockNumbersArr.join() };
      if (this.requisitionId)
        params.RequisitionId = this.requisitionId;

      this.crudService.get(
        ModulesBasedApiSuffix.INVENTORY,
        InventoryModuleApiSuffixModels.STOCKORDER_ITEMS,
        undefined, false,
        prepareRequiredHttpParams(params)
      ).subscribe((response) => {
        //this.stockCodes --> has backup of manual stock and stock order stocks based on these stock array list is maintanied 
        let stockCodesModel = []; stockCodesModel = response.resources;
        if (response?.isSuccess && response?.resources) {
          if (stockCodesModel.length > 0) {
            let arr = [];
            this.stockCodes = this.stockCodes.filter(x => x.type == "M");//reset and consider only manual stock codes
            stockCodesModel.forEach((stockCodeElement) => {
              let filterstock = this.stockCodes.filter(x => x.stockCode == stockCodeElement.stockCode);
              if (filterstock?.length == 0)
                this.stockCodes.push({ stockCode: stockCodeElement.stockCode, type: 'O' });

              let requiredQuantity;
              let filter; filter = this.stockItemsFormArray.value.filter(x => x.stockCode == stockCodeElement.stockCode);
              let findIndex = this.stockItemsFormArray.value.findIndex(x => x.stockCode == stockCodeElement.stockCode);

              if ((filter?.length > 0)) { // existing in manual stocks added
                filter = filter[0];
                requiredQuantity = (filter?.type == 'M') ? (parseInt(filter.tempRequiredQuantity) + parseInt(stockCodeElement.requiredQty)) : parseInt(stockCodeElement.requiredQty);
                let type = null;
                if (filter?.type == 'M') {
                  stockCodeElement.type = 'M';
                  stockCodeElement.tempRequiredQuantity = parseInt(filter.tempRequiredQuantity);
                }
                // let costprice = parseFloat(stockCodeElement.costprice);
                let finalData; finalData = this.setData(stockCodeElement, requiredQuantity);
                this.stockItemsFormArray.controls[findIndex] = finalData;
                this.fullListAllSubTotal();
              } else { // not existing manual so adding new stocks added
                let requiredQuantity = stockCodeElement.requiredQty ? parseInt(stockCodeElement.requiredQty) : 0;
                //let costprice = stockCodeElement.costprice ? parseFloat(stockCodeElement.costprice) : null;
                let finalData; finalData = this.setData(stockCodeElement, requiredQuantity);
                this.stockItemsFormArray.push(finalData);
                this.fullListAllSubTotal();
              }
            });
          }
          else {
            this.stockCodes = this.stockCodes.filter(x => x.type == "M");
            this.fullListAllSubTotal();
          }
        }
        else {
          this.stockItemsFormArray.value.forEach((element, i) => {
            if (element.type == 'M') {
              element.requiredQuantity = element.tempRequiredQuantity ? element.tempRequiredQuantity : element.requiredQuantity;
              this.stockItemsFormArray.controls[i].get('requiredQuantity').setValue(element.requiredQuantity);
            }
          });
          this.fullListAllSubTotal();
        }
        this.resetOnlyManualStocks(); //if unchecked remove the unchecked stocks
        this.fullListAllSubTotal();
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    }
    else {
      this.stockCodes = this.stockCodes.filter(x => x.type == "M");//reset and consider only manual stock codes 
      this.resetOnlyManualStocks(); //if unchecked remove the unchecked stocks
      this.stockItemsFormArray.value.forEach((element, i) => {
        if (element.type == 'M') {
          element.requiredQuantity = element.tempRequiredQuantity ? element.tempRequiredQuantity : element.requiredQuantity;
          this.stockItemsFormArray.controls[i].get('requiredQuantity').setValue(element.requiredQuantity);
        }
      });
      this.fullListAllSubTotal();
    }

  }
  resetOnlyManualStocks() { //if unchecked remove the unchecked stocks
    let i = this.stockItemsFormArray.value?.length;
    while (i--) {
      let filter = this.stockCodes.filter(x => (x.stockCode == this.stockItemsFormArray.value[i].stockCode));
      if (filter?.length == 0) {
        this.stockItemsFormArray.removeAt(i);
      }
    }
  }
  setData(stockCodeElement, requiredQuantity) {
    let costPrice; costPrice = stockCodeElement.costPrice ? Number(stockCodeElement.costPrice)?.toFixed(2) : stockCodeElement.contractCost ? Number(stockCodeElement.contractCost)?.toFixed(2) : 0
    let stockCodesDetailsFormGroup = this.formBuilder.group({
      'stockCode': stockCodeElement.stockCode,
      'stockDescription': stockCodeElement.stockDescription,
      'requestedQuantity': stockCodeElement.requestedQty,
      'tempRequiredQuantity': stockCodeElement.tempRequiredQuantity,
      'requiredQuantity': requiredQuantity,
      'stockOrderNo': stockCodeElement.stockOrderNo,
      'minimumThreshold': stockCodeElement.minimumThreshold,
      'maximumThreshold': stockCodeElement.maximumThreshold,
      'stockOnHand': stockCodeElement.stockOnHand,
      'ibtAvailableQty': stockCodeElement.ibtAvailableQty,
      'ibtOrderQty': stockCodeElement.ibtOrderQty,
      'requisitionQty': requiredQuantity - stockCodeElement.ibtAvailableQty,
      'stockId': stockCodeElement.stockId,
      'itemConditionName': stockCodeElement?.itemConditionName,
      'requisitionIdForDelete': [{ value: null, disabled: true }], // check for this line as we have to pass requisition id
      'stockOrderId': stockCodeElement.stockOrderId ? stockCodeElement.stockOrderId : null,
      'discrepancyReason': stockCodeElement.reasonForDiscrepancy,
      'contractCost': stockCodeElement.contractCost ? Number(stockCodeElement.contractCost)?.toFixed(2) : '0.00',
      'costPrice': costPrice,
      'subTotal': costPrice ? Number(requiredQuantity * costPrice)?.toFixed(2) : '0.00',
      'type': stockCodeElement.type == "M" ? stockCodeElement.type : null
    });
    return stockCodesDetailsFormGroup;
  }
  getDifference(array1, array2) {
    return array1.filter(object1 => {
      return !array2.some(object2 => {
        return object1.stockId === object2.stockId;
      });
    });
  }
  getSimilar(array1, array2) {
    return array1.filter(object1 => {
      return array2.some(object2 => {
        return object1.stockId === object2.stockId;
      });
    });
  }
  addFullListSubTotal() {
    let stockCodesDetailsArray = this.stockCodeAndDescriptionList;
    stockCodesDetailsArray.forEach(element => {
      let subtotal = parseFloat(element.subTotal);
      this.fullListSubTotal += subtotal;
    });
  }
  createRequisitionDataTable(stockCodesModel, updateMode = false) {
    // Create variable to store list of stock orders for comparison
    this.isArrayEmpty = false;
    let stockCodesDetailsArray = this.stockItemsFormArray;
    for (const stockCode of stockCodesModel) {
      if (!stockCode?.flag) {
        let stockCodesDetailsFormGroup = this.formBuilder.group({
          'stockCode': stockCode.stockCode,
          'stockDescription': stockCode.stockDescription,
          'requestedQuantity': stockCode.requestedQty,
          'requiredQuantity': stockCode.requiredQty, // [stockCode.requiredQty, [Validators.min(1)]]
          'tempRequiredQuantity': (stockCode.type == 'M') ? stockCode.requiredQty : null,
          'stockOrderNo': stockCode.stockOrderNo,
          'minimumThreshold': stockCode.minimumThreshold,
          'maximumThreshold': stockCode.maximumThreshold,
          'stockOnHand': stockCode.stockOnHand,
          'ibtAvailableQty': stockCode.ibtAvailableQty,
          'ibtOrderQty': stockCode.ibtOrderQty,
          'itemConditionName': stockCode.itemConditionName,
          'requisitionQty': stockCode.requiredQty - stockCode.ibtOrderQty,
          'stockId': stockCode.stockId,
          'requisitionIdForDelete': [{ value: updateMode ? this.fullListInterbranchRequisitionModel['requisitionId'] : null, disabled: true }], // check for this line as we have to pass requisition id
          'stockOrderId': stockCode.stockOrderId ? stockCode.stockOrderId : null,
          'discrepancyReason': [{value: stockCode.reasonForDiscrepancy ? stockCode.reasonForDiscrepancy : null, disabled: true}],
          'contractCost': stockCode.contractCost ? Number(stockCode.contractCost)?.toFixed(2) : '0.00',
          'costPrice': stockCode.costPrice ? Number(stockCode.costPrice)?.toFixed(2) : '0.00',
          'subTotal': stockCode.subTotal ? Number(stockCode.subTotal)?.toFixed(2) : '0.00',
          'type': stockCode.type ? stockCode.type : null
        });
        let subtotal = (+stockCodesDetailsFormGroup.get('requisitionQty').value) * (+stockCodesDetailsFormGroup.get('costPrice').value);
        let subtotals = Number(subtotal)?.toFixed(2);
        stockCodesDetailsFormGroup.get('subTotal').setValue(subtotals);
        if (stockCodesDetailsFormGroup.get('contractCost').value == null ||
          stockCodesDetailsFormGroup.get('contractCost').value == 0.00 ||
          stockCodesDetailsFormGroup.get('contractCost').value < 0.00) {
          stockCodesDetailsFormGroup.get('costPrice').enable();
        }
        else
          stockCodesDetailsFormGroup.get('costPrice').disable();

        stockCodesDetailsFormGroup.get('requiredQuantity').setValidators([Validators.required]);
        stockCodesDetailsFormGroup.controls['requiredQuantity'].setValidators(Validators.compose([Validators.min(1), Validators.required]));

        stockCodesDetailsFormGroup.get('ibtOrderQty').valueChanges.pipe(distinctUntilChanged()).subscribe(ibtOrderQty => {
          stockCodesDetailsFormGroup.get('requisitionQty').setValue((+stockCodesDetailsFormGroup.get('requiredQuantity').value) - (+ibtOrderQty));

          let subtotal = (+stockCodesDetailsFormGroup.get('requisitionQty').value) * (+stockCodesDetailsFormGroup.get('costPrice').value);
          let subtotals = Number(subtotal)?.toFixed(2);
          stockCodesDetailsFormGroup.get('subTotal').setValue(subtotals);
          this.fullListSubTotal = 0;
          this.addFullListSubTotal();
        });
        stockCodesDetailsArray.push(stockCodesDetailsFormGroup);
      }
    }
    this.requisitionCreationForm = setRequiredValidator(this.requisitionCreationForm, ['warehouseId', 'requisitionDate', 'stockOrderTypeId', 'priorityId', 'LocationId', 'Motivation', 'supplierId']);
  }
  costPriceChange(value, index) {
    this.isStockChanged = true;
    if (parseInt(value) && parseInt(value) <= 0) {
      this.snackbarService.openSnackbar("Required quantity should be greater than 0.", ResponseMessageTypes.WARNING)
      return;
    }
    let requiredQuantity = this.stockItemsFormArray.controls[index].get('requiredQuantity').value;
    let ibtOrderQty = this.stockItemsFormArray.controls[index].get('ibtOrderQty').value;
    this.stockItemsFormArray.controls[index].get('requisitionQty').setValue(requiredQuantity);
    let requisitionQty = requiredQuantity - ibtOrderQty;
    let costPrice = this.stockItemsFormArray.controls[index].get('costPrice').value;
    let subTotal = (requisitionQty * costPrice).toFixed(2);
    this.stockItemsFormArray.controls[index].get('subTotal').setValue(subTotal);
    this.fullListAllSubTotal();
  }
  requiredQuantityChange(value, index) {
    this.isStockChanged = true;
    if (parseInt(value) && parseInt(value) <= 0) {
      this.snackbarService.openSnackbar("Required quantity should be greater than 0.", ResponseMessageTypes.WARNING)
      return;
    }
    this.stockItemsFormArray.controls[index]?.get('ibtOrderQty').setValue(0);
    this.stockItemsFormArray.controls[index]?.get('discrepancyReason').setValue(null);
    this.stockItemsFormArray.controls[index]?.get('discrepancyReason').disable();
    let requiredQuantity = this.stockItemsFormArray.controls[index].get('requiredQuantity').value;
    let ibtOrderQty = this.stockItemsFormArray.controls[index].get('ibtOrderQty').value;
    let requisitionQty = requiredQuantity - ibtOrderQty;
    this.stockItemsFormArray.controls[index].get('requisitionQty').setValue(requisitionQty);

    let costPrice = this.stockItemsFormArray.controls[index].get('costPrice').value;
    let subTotal = (requisitionQty * costPrice).toFixed(2);
    this.stockItemsFormArray.controls[index].get('subTotal').setValue(subTotal);
    this.fullListAllSubTotal();
    let stockCode = this.stockItemsFormArray.controls[index].get('stockCode').value;
    let interBranchData; interBranchData = this.fullListInterbranchRequisitionModel['interBranchTransfers'];

    // when ever the Required Qty is changed correspoding ibt order has to be cleared
    interBranchData?.forEach(element => {
      element.interBranchStockDetails = element.interBranchStockDetails.filter(x => x.stockCode != stockCode);
      let sum = 0;
      element.interBranchStockDetails.forEach(element => {
        sum += parseInt(element.ibtOrderQty);
      });
      element.ibtOrderQty = sum;
    });
    interBranchData = interBranchData?.filter(x => parseInt(x.ibtOrderQty) != 0);
    this.fullListInterbranchRequisitionModel['interBranchTransfers'] = interBranchData;

    this.fullListAllSubTotal();
  }
  fullListAllSubTotal() {
    this.fullListSubTotal = 0;
    this.stockItemsFormArray.value.forEach(element => {
      let subtotal; subtotal = parseFloat(element.subTotal);

      this.fullListSubTotal += subtotal;
    });
  }
  addStockNumberToTable() {

    if (!this.stockCodeDescriptionForm?.get('stockId')?.value ||
      !this.stockCodeDescriptionForm?.get('stockDescription')?.value ||
      !this.stockCodeDescriptionForm?.get('requestedOty')?.value || this.stockCodeDescriptionForm?.get('requestedOty')?.value == 0) {
      this.isAdd = true;
      return;
    } else {
      this.isAdd = false;
    }
    let flag = true; let params;
    flag = this.stockOrderTypeList.find(x => x?.id == this.requisitionCreationForm.get('stockOrderTypeId').value.toLowerCase()).displayName.toLowerCase() === 'repair stock' ? false : true;

    if (flag) {
      params = {
        stockId: this.filteredStockCodes.find(x => x.displayName == this.stockCodeDescriptionForm.get('stockId').value).id,
        // stockId :this.stockCodeDescriptionForm.get('stockId').value,
        warehouseId: flag ? this.requisitionCreationForm.get('warehouseId').value : null
      }
    } else {
      params = {
        stockId: this.filteredStockCodes.find(x => x.displayName == this.stockCodeDescriptionForm.get('stockDescription').value).id,
        // stockId :this.stockCodeDescriptionForm.get('stockDescription').value,  
        warehouseId: flag ? this.requisitionCreationForm.get('warehouseId').value : null
      }
    }
    this.isStockChanged = true;
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.ADD_REQUISITION_ITEM,
      undefined, false, prepareRequiredHttpParams(params)
    ).subscribe(response => {
      //  this.stockCodeDescriptionForm = clearFormControlValidators(this.stockCodeDescriptionForm, ["stockId","stockDescription","requestedOty"]);
      if (response.isSuccess && response.statusCode == 200) {
        if (response.resources) {
          this.stockCodes.push({ stockCode: response.resources.stockCode, type: 'M' });

          response.resources.requestedQty = this.stockCodeDescriptionForm.get('requestedOty').value;
          response.resources.requiredQty = response.resources.requestedQty;
          response.resources.requisitionQty = response.resources.requiredQty - response.resources.ibtOrderQty;
          response.resources.subTotal = response.resources.requisitionQty * response.resources.costPrice;
          response.resources.type = 'M';
          this.fullListSubTotal += response.resources.subTotal;
          this.stockCodeAndDescriptionList.push(response.resources);
          this.stockCodeDescriptionForm.reset();
          this.createRequisitionDataTable([response.resources]);
          this.snackbarService.openSnackbar('Stock code added manually', ResponseMessageTypes.SUCCESS);
          this.rxjsService.setGlobalLoaderProperty(false);
        } else {
          this.rxjsService.setGlobalLoaderProperty(false);
          this.snackbarService.openSnackbar('Stock not added with this warehouse. Kindly add in stock maintenance', ResponseMessageTypes.WARNING);
        }
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  openInterBranchModal(rowindex, ItemId, RequiredQty, ibtOrderQty) {

    if (this.requisitionCreationForm.get('priorityId').value == '' && this.requisitionCreationForm.get('stockOrderTypeId').value == '') {
      this.snackbarService.openSnackbar('Select Stock Order Type and Priority', ResponseMessageTypes.WARNING)
      return;
    } else if (this.requisitionCreationForm.get('priorityId').value == '') {
      this.snackbarService.openSnackbar('Select Stock Priority', ResponseMessageTypes.WARNING);
      return;
    } else if (this.requisitionCreationForm.get('stockOrderTypeId').value == '') {
      this.snackbarService.openSnackbar('Select Stock Order Type', ResponseMessageTypes.WARNING);
      return;
    }

    const dialogReff = this.dialog.open(StockOrderInterbranchModalComponent, {
      width: '600px',
      data: {
        ItemId,
        WarehouseId: this.requisitionCreationForm.get('warehouseId').value,
        RequisitionId: this.requisitionCreationForm.get('requisitionId').value,
        loggedInWarehouseId: this.loggedUser.warehouseId,
        StockOrderTypeId: this.requisitionCreationForm.get('stockOrderTypeId').value,
        PriorityId: this.requisitionCreationForm.get('priorityId').value,
        OrderPriority: this.priorityTypeRef.nativeElement.selectedOptions[0].text.trim().toLowerCase(),
        InterBranchOrderStatus: 'New',
        PONumber: '',
        CreatedUserId: this.loggedUser.userId,
        RequiredQty,
        ibtOrderQty: ibtOrderQty
      }, disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {


      if (result?.data?.interBranchWarehouses) {
        this.snackbarService.openSnackbar('Interbranch stock order added successfully!', ResponseMessageTypes.SUCCESS);
        this.stockItemsFormArray.controls[rowindex].get('discrepancyReason').setValue(result?.data?.reasonForDiscrepancy);
        this.stockItemsFormArray.controls[rowindex].get('ibtOrderQty').setValue(result?.data?.selectedQtyFinal);

        let requiredQuantity = this.stockItemsFormArray.controls[rowindex].get('requiredQuantity').value;
        let ibtOrderQty = this.stockItemsFormArray.controls[rowindex].get('ibtOrderQty').value;
        if (parseInt(ibtOrderQty) > 0)
          this.stockItemsFormArray.controls[rowindex].get('discrepancyReason').enable();
        else
          this.stockItemsFormArray.controls[rowindex].get('discrepancyReason').disable();

        let requisitionQty = requiredQuantity - ibtOrderQty;
        this.stockItemsFormArray.controls[rowindex].get('requisitionQty').setValue(requisitionQty);

        if (this.fullListInterbranchRequisitionModel['interBranchTransfers']?.length > 0) {

          let arr = []; arr = result?.data?.interBranchWarehouses;
          arr.forEach((elem, i) => { //if (issue|to) warehouse exists already delete and add stock detail
            elem.ToWarehouseId = elem?.toWarehouseId ? elem.toWarehouseId : elem.ToWarehouseId;
            let filterObj = this.fullListInterbranchRequisitionModel['interBranchTransfers'].filter(fil => (fil.toWarehouseId == elem.ToWarehouseId || fil.ToWarehouseId == elem.ToWarehouseId));
            let mainIndex = this.fullListInterbranchRequisitionModel['interBranchTransfers'].findIndex(fil => (fil.toWarehouseId == elem.ToWarehouseId || fil.ToWarehouseId == elem.ToWarehouseId));

            if (filterObj.length > 0) {
              let subObj = {
                itemId: elem.itemId ? elem.itemId : elem.ItemId, stockCode: result?.data?.stockCode, stockDescription: result?.data?.stockDescription,
                FromWarehouseId: elem.FromWarehouseId, ToWarehouseId: elem?.toWarehouseId ? elem.toWarehouseId : elem.ToWarehouseId, ibtOrderQty: elem.Quantity
              };
              let subIndex = filterObj[0].interBranchStockDetails?.findIndex(y => (y.itemId == elem?.ItemId || y.itemId == elem?.itemId))

              if (subIndex >= 0) { //if stock exists remove and add
                this.fullListInterbranchRequisitionModel['interBranchTransfers'][mainIndex]?.interBranchStockDetails?.splice(subIndex, 1);
                this.fullListInterbranchRequisitionModel['interBranchTransfers'][mainIndex]?.interBranchStockDetails.push(subObj);
              }
              else //otherwise add   
                this.fullListInterbranchRequisitionModel['interBranchTransfers'][mainIndex]?.interBranchStockDetails.push(subObj);

              let qtyTotal = 0;
              this.fullListInterbranchRequisitionModel['interBranchTransfers'][mainIndex]?.interBranchStockDetails.forEach((interBranchStockDetailsEle, k) => {
                qtyTotal = parseInt(interBranchStockDetailsEle.ibtOrderQty) + qtyTotal;
              });
              //total of all ibtOrderQty based on stock code is finaly set to the (to|issue) warehouse
              this.fullListInterbranchRequisitionModel['interBranchTransfers'][mainIndex].ibtOrderQty = qtyTotal;
            } else if (filterObj.length == 0) {

              let obj = this.setStructure(elem, result);
              this.fullListInterbranchRequisitionModel['interBranchTransfers'].push(obj);
            }

          });
          let filter = this.fullListInterbranchRequisitionModel.interBranchTransfers.filter(x => parseInt(x.ibtOrderQty) > 0);
          this.fullListInterbranchRequisitionModel.interBranchTransfers = filter;

        }
        else {

          if (result?.data?.interBranchWarehouses?.length > 0) {
            let interBranchWarehouseArr = []; let arr = []; arr = result?.data?.interBranchWarehouses;
            arr.forEach(element => {
              let obj = this.setStructure(element, result);
              interBranchWarehouseArr.push(obj);
            });
            this.fullListInterbranchRequisitionModel['interBranchTransfers'] = interBranchWarehouseArr;
          }
          let filter = this.fullListInterbranchRequisitionModel.interBranchTransfers.filter(x => parseInt(x.ibtOrderQty) > 0);
          this.fullListInterbranchRequisitionModel.interBranchTransfers = filter;

        }
        this.fullListAllSubTotal();
      }
      this.dialog.closeAll();
      this.rxjsService.setDialogOpenProperty(false);
    });
  }
  navigateToIBTRequestView(interBranchStockOrderId, interbranchTransfer) {
    if (interbranchTransfer?.ibtrqNumber && interbranchTransfer?.ibtrqNumber != '-' && interBranchStockOrderId) {
      this.router.navigate(['/inventory/inter-branch/inter-branch-transfer/view'], { queryParams: { interBranchStockOrderId: interBranchStockOrderId, isCurrentBranchRequest: false } });
    }
  }
  setStructure(element, result) {

    let obj; let filter = this.warehouseList.filter(x => x.id == this.requisitionCreationForm.get('warehouseId').value);
    obj = {
      FromWarehouseId: element.FromWarehouseId,
      ToWarehouseId: element.ToWarehouseId,
      warehouse: element.warehouse,
      requester: this.loggedUser.displayName,
      requestWarehouse: element.requestWarehouse ? element.requestWarehouse : filter[0].displayName,
      issueWarehouse: element.warehouse,
      ibtOrderQty: element.Quantity,
      interBranchStockDetails: []
    }
    obj.interBranchStockDetails.push({
      itemId: element.ItemId,
      ibtOrderQty: element.Quantity,
      stockCode: result?.data?.stockCode,
      stockDescription: result?.data?.stockDescription,
      FromWarehouseId: element.FromWarehouseId,
      ToWarehouseId: element.ToWarehouseId
    });
    return obj;
  }
  get stockItemsFormArray(): FormArray {
    if (this.requisitionCreationForm !== undefined) {
      return (<FormArray>this.requisitionCreationForm.get('Items'));
    }
  }

  saveAsDraft(type) {
    this.isSubmitDoc = false;
     this.requisitionCreationForm.markAsUntouched();
    // if (this.requisitionCreationForm.invalid || this.listOfFiles.length == 0) {// comment this line for bug no 236, 237
    if (this.requisitionCreationForm.invalid) {
      return this.requisitionCreationForm.markAllAsTouched();
    }
    if (this.stockItemsFormArray.controls.length == 0) {
      this.isArrayEmpty = true;
      this.snackbarService.openSnackbar('Add atleast one Stock Code to Full List.', ResponseMessageTypes.WARNING)
      return;
    }
    // add this line for bug no 236, 237
    let formArray = this.stockItemsFormArray.getRawValue();
    this.contractPriceData = formArray?.filter(x => (x.contractCost == null || !x.contractCost || parseFloat(x.contractCost) == 0));

    if (this.listOfFiles?.length == 0 && this.contractPriceData?.length > 0) {
      this.isSubmitDoc = true;
      this.snackbarService.openSnackbar('Add atleast one File.', ResponseMessageTypes.WARNING)
      return;
    }
    // end this line for bug no 236, 237
    this.requisitionCreationForm.get('createdUserId').setValue(this.requisitionId ? this.loggedUser.userId : this.loggedUser.userId);
    this.requisitionCreationForm.get('modifiedUserId').setValue(this.requisitionId ? this.loggedUser.userId : this.loggedUser.userId);
    this.rxjsService.setFormChangeDetectionProperty(true);
    this.createPostRequisitionApi(type)?.subscribe((response) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.navigateToList();
      }
    });
  }

  // checkValidation() { //handled in backend
  //   return new Promise((resolve, reject) => {
  //     var totalSubTotal = 0;
  //     this.requisitionCreationForm.value.Items.forEach(element => {
  //       let subtotal = parseFloat(element.subTotal);
  //       totalSubTotal += subtotal;
  //     });
  //     if (+this.fromValue <= totalSubTotal && +this.toValue >= totalSubTotal) {
  //       resolve(true);
  //     }
  //     else {
  //       // let message = "You don't have access range for " + this.fromValue + ' to ' + this.toValue + '.Please contact administrator for further access';
  //       this.snackbarService.openSnackbar('The Total value for the requisition exceeds the limit setup for your user account.', ResponseMessageTypes.WARNING);
  //       resolve(false);
  //     }
  //   });
  // }
  noChangeDetect() {
    this.rxjsService.setFormChangeDetectionProperty(true);
    this.snackbarService.openSnackbar("No Changes were detected -", ResponseMessageTypes.WARNING);
  }
  createRequisition(type) {
    this.isSubmit = true;

    if (this.isOnceOff && !this.requisitionCreationForm?.get('stockOrderIds').value) {
      return;
    }
    this.isSubmitDoc = true;
    if (this.isStockChanged)
      this.rxjsService.setFormChangeProperty(false);

    //this.rxjsService.setFormChangeDetectionProperty(false);

    this.requisitionCreationForm = setRequiredValidator(this.requisitionCreationForm, ['warehouseId', 'requisitionDate', 'stockOrderTypeId', 'priorityId', 'LocationId', 'Motivation', 'supplierId']);

     this.requisitionCreationForm.markAsUntouched();
    if (this.requisitionCreationForm?.value.Motivation == null || (this.requisitionCreationForm.invalid)) {
      return this.requisitionCreationForm.markAllAsTouched();;
    }



    let formArray = this.stockItemsFormArray.getRawValue();
    let filterData = formArray?.filter(x => (x.costPrice == null || !x.costPrice || parseFloat(x.costPrice) == 0));

    if (filterData && filterData?.length > 0) {
      return this.snackbarService.openSnackbar("Cost Price must not be empty or 0.", ResponseMessageTypes.WARNING);
    }

    this.contractPriceData = formArray?.filter(x => (x.contractCost == null || !x.contractCost || parseFloat(x.contractCost) == 0));

    if (this.listOfFiles?.length == 0 && this.contractPriceData?.length > 0) return;

    if (this.selectedTabIndex == 2 && this.requisitionReasonsMsg && this.rqnStatusName == "Pending Approval" && !this.requisitionCreationForm.get('reason').value) return;

    if (this.requisitionId && (this.selectedTabIndex == 0 || this.selectedTabIndex == 2) && this.fullListInterbranchRequisitionModel?.createdUserId != this.loggedUser.userId && this.fullListInterbranchRequisitionModel?.canApprove && this.fullListInterbranchRequisitionModel?.canCancel && this.fullListInterbranchRequisitionModel?.canReject) {
      if (this.selectedTabIndex == 2 && !this.approvalStatusName) {
        // this.noChangeDetect(); return;
      }
    }
    else if (this.requisitionId && (this.selectedTabIndex == 0) && this.requisitionCreationForm.invalid && !this.isStockChanged) {
      this.rxjsService.setFormChangeDetectionProperty(true);
      this.snackbarService.openSnackbar("No Changes were detected", ResponseMessageTypes.WARNING);
      return;
    }

    if (this.requisitionId && this.selectedTabIndex == 2 && this.fullListInterbranchRequisitionModel?.createdUserId != this.loggedUser.userId && this.fullListInterbranchRequisitionModel?.canApprove && this.fullListInterbranchRequisitionModel?.canCancel && this.fullListInterbranchRequisitionModel?.canReject) {
      if (!this.approvalStatusName) {
        this.snackbarService.openSnackbar("Please select the status.", ResponseMessageTypes.ERROR);
        return;
      }
    }

    if (this.requestType == 'inventory-task-list') {
      this.requisitionCreationForm = clearFormControlValidators(this.requisitionCreationForm, ['warehouseId', 'requisitionDate', 'stockOrderTypeId']);
      this.requisitionCreationForm.get('stockOrderIds')?.clearValidators();
      this.requisitionCreationForm.get('supplierId')?.clearValidators();
      this.requisitionCreationForm.get('requiredQuantity')?.clearValidators();
      this.requisitionCreationForm.get('reason')?.clearValidators();
    }
    if (this.requestType != 'inventory-task-list' && this.enableStockOrder && this.requisitionCreationForm.invalid) {
      this.requisitionCreationForm.get('stockOrderIds').markAsTouched();
      return;
    }

    this.rqnStatusError = false;
    if (this.selectedTabIndex == 2 && this.requestType == 'inventory-task-list' &&
      !this.requisitionCreationForm.get('rqnStatusId').value) {
      this.rqnStatusError = true;
      return;
    }
    let filter = this.statusList.filter(x => x.id == this.requisitionCreationForm.get('rqnStatusId').value);
    if (this.requisitionId && this.fullListInterbranchRequisitionModel?.createdUserId != this.loggedUser.userId
      && this.selectedTabIndex == 2 && this.requestType == 'inventory-task-list' && this.requisitionCreationForm.get('rqnStatusId').value
      && (filter?.length > 0 && (filter[0].displayName == 'Rejected' || filter[0].displayName == 'Cancelled') && !this.requisitionCreationForm.get('reason').value)) {
      this.snackbarService.openSnackbar('Reason is required', ResponseMessageTypes.WARNING);
      return;
    }
    if (this.stockItemsFormArray.controls.length == 0) {
      this.isArrayEmpty = true;
      this.snackbarService.openSnackbar('Add atleast one Stock Code to Full List.', ResponseMessageTypes.WARNING);
      return;
    }
    let subTotalMsg: boolean = false; let contractValidation: boolean = false;
    this.requisitionCreationForm.value.Items.forEach(x => {
      if (x.subTotal == null || x.subTotal <= 0) {
        subTotalMsg = true;
      }
      if (x.contractCost == null || x.contractCost <= 0) {
        contractValidation = true;
      }
    });
    if (contractValidation && this.listOfFiles.length == 0) {
      this.snackbarService.openSnackbar('Supporting documents is required', ResponseMessageTypes.WARNING)

      return;
    }
    this.requisitionCreationForm.get('createdUserId').setValue(this.requisitionId ? this.loggedUser.userId : this.loggedUser.userId);
    this.requisitionCreationForm.get('modifiedUserId').setValue(this.requisitionId ? this.loggedUser.userId : this.loggedUser.userId);
    this.rxjsService.setFormChangeDetectionProperty(true);
    if (this.selectedTabIndex == 0) { // Proceed : after clicking redirect to Interbranch tab
      let requisitionItems = this.stockItemsFormArray.getRawValue();
      requisitionItems?.forEach(element => {
        element.requestedQty = element.requestedQuantity;
        element.requiredQty = element.requiredQuantity;
        element.ibtOrderedQty = element.ibtOrderQty;
        element.requisitionQty = element.requisitionQty;
        element.costPrice = element.costPrice;
      });
      this.fullListInterbranchRequisitionModel.requisitionRequests = requisitionItems;
      let ibtAvailableQtyFilter = this.stockItemsFormArray.getRawValue()?.filter(x => parseInt(x.ibtOrderQty) > 0);
      let tabdata = { index: (ibtAvailableQtyFilter?.length > 0) ? 1 : 2 };
      this.onTabClicked(tabdata);
    }
    else if (this.selectedTabIndex == 1) { // Next : after clicking redirect to Requisition tab
      this.selectedTabIndex = 2;
    }
    else if (this.selectedTabIndex == 2) { // Create : after clicking redirect to list page
      // 1st Pop up
      let creationMsg: string = ''; let statusName: string = '';
      if (this.requestType == 'inventory-task-list') {
        let status = this.statusList.find(sta => sta.id == this.requisitionCreationForm.get('rqnStatusId').value)
        statusName = status?.displayName == 'Rejected' ? 'reject' : status?.displayName == 'Cancelled' ? 'cancel' : 'approve'
      }
      creationMsg = this.requestType == 'inventory-task-list' ? `Are you sure you want to ${statusName} the requisition?` :
        'Would you like to proceed for Approval?';

      const dialogReff = this.dialog.open(RequisitionCreationModalComponent, {
        width: '450px',
        data: {
          message: creationMsg,
          closeFlag: true,
          requisitionId: this.requisitionId,
          buttons: {
            cancel: 'No',
            create: 'Yes'
          }
        }, disableClose: true
      });
      dialogReff.afterClosed().subscribe(result => {
        if (!result) return;
        this.requisitionCreationForm.get('isSaved').setValue(false);

        this.createPostRequisitionApi(type)?.subscribe((response) => {
          if (response.isSuccess && response.statusCode == 200) {
            if (!this.requisitionId)
              this.fullListInterbranchRequisitionModel['requisitionNumber'] = response.resources?.requisitionNumber;
            // 2nd Pop up
            const dialogRequisitionId = this.dialog.open(RequisitionCreationModalComponent, {
              width: '450px',
              data: {
                message: this.requisitionId ? `Requisition ID ${this.fullListInterbranchRequisitionModel['requisitionNumber']} was updated.` : `Requisition ID ${this.fullListInterbranchRequisitionModel['requisitionNumber']} is generated.`, // <br />Would you like to proceed?
                closeFlag: false,
                requisitionId: this.requisitionId,
                buttons: {
                  create: 'Ok'
                }
              }, disableClose: true
            });
            dialogRequisitionId.afterClosed().subscribe(result => {
              if (!result) return;
              this.navigateToList();
              this.rxjsService.setDialogOpenProperty(false);
            });
          }
        })
        this.rxjsService.setDialogOpenProperty(false);
      });
    }
  }

  createPostRequisitionApi(type) {

    let status = this.statusList.find(sta => sta.id == this.requisitionCreationForm.get('rqnStatusId').value)

    let RequisitionBody = this.requisitionCreationForm.getRawValue();

    delete RequisitionBody.stockOrderIds;

    // if (RequisitionBody.Items && RequisitionBody.Items.filter(x => ((x.ibtOrderQty > 0) && (x.costPrice <= 0 || x.costPrice == null)))?.length > 0) {
    //   this.snackbarService.openSnackbar("Cost Price (R) value should be greater than 0.", ResponseMessageTypes.WARNING);
    //   return;
    // }
    RequisitionBody.userId = this.loggedUser.userId;
    RequisitionBody.supplierDocuments = this.supplierDocuments;
    RequisitionBody.RequisitionApprovalId = this.requestType == 'inventory-task-list' ? this.referenceId : '';
    RequisitionBody.action = this.requisitionId && status != undefined && this.selectedTabIndex == 2 ? status.displayName : '';

    RequisitionBody.Requisitioncreation = !this.requisitionId && this.selectedTabIndex == 2 ? true :
      this.requisitionId && this.selectedTabIndex == 2 && this.requestType == 'requisition-list' && (this.rqnStatusName == 'New' || this.rqnStatusName == 'Save as Draft') ? true : false;
    RequisitionBody.requisitionDate = this.datePipe.transform(RequisitionBody.requisitionDate, 'yyyy-MM-dd hh:mm:ss a');

    RequisitionBody.Items.forEach(element => {
      element.costPrice = element.costPrice == null ? 0.00 : element.costPrice;
      element.subTotal = element.subTotal == null ? 0.00 : element.subTotal;
      element.itemId = element.stockId;
    });
    if (type == 'save-as-draft') {
      RequisitionBody.IsUpdate = false;
      RequisitionBody.IsDraft = true;
      RequisitionBody.IsProceed = false;
    }
    else if (type == 'submit') {
      if (this.selectedTabIndex == 0) {
        RequisitionBody.IsUpdate = false;
        RequisitionBody.IsDraft = false;
        RequisitionBody.IsProceed = true;
      }
      else if (this.selectedTabIndex == 2 && this.requisitionId) {
        RequisitionBody.IsDraft = false;
        RequisitionBody.IsProceed = false;
        RequisitionBody.IsCancelled = status?.displayName == 'Cancelled' ? true : false;
        RequisitionBody.IsRejected = (this.rqnStatusName != 'Rejected' && status?.displayName == 'Rejected') ? true : false;
        RequisitionBody.IsApproved = status?.displayName == 'Approved' ? true : false;
        RequisitionBody.IsUpdate = (status?.displayName == 'Cancelled' || status?.displayName == 'Rejected' || status?.displayName == 'Approved') ? false : true;
      }
      else if (this.selectedTabIndex == 2) {
        RequisitionBody.IsUpdate = false;
        RequisitionBody.IsDraft = false;
        RequisitionBody.IsProceed = false;
        RequisitionBody.IsCancelled = status?.displayName == 'Cancelled' ? true : false;
        RequisitionBody.IsRejected = (this.rqnStatusName != 'Rejected' && status?.displayName == 'Rejected') ? true : false;
        RequisitionBody.IsApproved = status?.displayName == 'Approved' ? true : false;
      }
    }

    RequisitionBody.interBranchWarehouses = this.fullListInterbranchRequisitionModel['interBranchTransfers'];
    //RequisitionBody.supplierId = RequisitionBody.supplierId ? RequisitionBody.supplierId.value : '';
    var formData = new FormData();
    formData.append('json', JSON.stringify(RequisitionBody));
    this.fileList.forEach(file => {
      formData.append('file', file);
    });

    let sendParams = {
      "requisitionId": this.requisitionId,
      "approvalId": this.loggedUser.userId,
      "rqnStatusId": this.requisitionCreationForm.get('rqnStatusId').value,
      "approvalDate": new Date(),
      "requisitionApprovalId": this.referenceId,
      "reason": this.requisitionCreationForm.get('reason').value,
      "modifiedDate": new Date(),
      "modifiedUserId": this.loggedUser.userId,
      "priorityId": this.fullListInterbranchRequisitionModel?.priorityId,
      "requisitionDate": this.datePipe.transform(this.fullListInterbranchRequisitionModel?.requisitionDate, 'yyyy-MM-dd hh:mm:ss a'),
      "warehouseId": this.fullListInterbranchRequisitionModel?.warehouseId,
      "stockOrderTypeId": this.fullListInterbranchRequisitionModel?.orderTypeId,
      "locationId": this.fullListInterbranchRequisitionModel?.locationId,
      "interBranchWarehouses": this.fullListInterbranchRequisitionModel['interBranchTransfers'],
      "userId": this.loggedUser.userId
    }
    sendParams = { ...sendParams, ...RequisitionBody };
    if (this.approvalStatusName) {
      sendParams['action'] = this.approvalStatusName;
    }
    if (this.requisitionId) {
      var formData = new FormData();
      this.fileList.forEach(file => {
        formData.append('file', file);
      });
      //   // We have already called POST Api so thats why we have fullListInterbranchRequisitionModel data now call PUT
      formData.append('json', JSON.stringify(sendParams));
      return this.crudService.create(
        ModulesBasedApiSuffix.INVENTORY, this.selectedTabIndex == 2 && this.requestType == 'inventory-task-list' ?
        InventoryModuleApiSuffixModels.REQUISITION_GET_DETAILS : InventoryModuleApiSuffixModels.REQUISITION_SAVE,
        formData
      ).pipe(tap(() => {
        this.rxjsService.setGlobalLoaderProperty(false);
      }))
    } else {
      // If we dont have fullListInterbranchRequisitionModel data means we dont have called POST api now call POST api
      return this.crudService.create(
        ModulesBasedApiSuffix.INVENTORY,
        InventoryModuleApiSuffixModels.REQUISITION_SAVE,
        formData
      ).pipe(tap((res) => {
        this.fullListInterbranchRequisitionModel['requisitionNumber'] = res.resources?.requisitionNumber;
        this.rxjsService.setGlobalLoaderProperty(false);
      }))
    }
  }

  getFullListInterBranchRequisitionData(requisitionId) {
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.REQUISITION_EDIT, requisitionId, true, null).subscribe(response => {
      if (response.isSuccess && response.statusCode === 200) {
        this.supplierDocuments = []; this.fileList = [];
        this.stockItemsFormArray.clear();
        this.fullListInterbranchRequisitionModel = {};
        response?.resources?.requisitionRequests?.forEach(val => {
          val.contractCost = (val.contractCost) ? val.contractCost.toFixed(2) : '0.00';
          val.costPrice = (val.costPrice) ? val.costPrice.toFixed(2) : '0.00';
          val.subTotal = (val.subTotal) ? val.subTotal.toFixed(2) : '0.00';
          return val;
        });
        this.fullListInterbranchRequisitionModel = response.resources;
        this.requisitionCreationForm.get('requisitionId').setValue(this.fullListInterbranchRequisitionModel['requisitionId']);
        this.requisitionCreationForm.get('warehouseId').setValue(this.fullListInterbranchRequisitionModel['warehouseId'], { emitEvent: false });
        this.requisitionCreationForm.get('requisitionDate').setValue(new Date(this.fullListInterbranchRequisitionModel['requisitionDate']));
        this.requisitionCreationForm.get('stockOrderTypeId').setValue(this.fullListInterbranchRequisitionModel['orderTypeId']);
        this.supplierDocuments = response.resources?.supplierDocuments;
        this.listOfFiles = [];
        if (response.resources?.supplierDocuments.length > 0) {
          response.resources?.supplierDocuments.forEach(element => {
            this.listOfFiles.push({ id: element.requisitionSupplierDocumentId, name: element.docName, path: element.path })
          });
        }
        this.fullListInterbranchRequisitionModel['items'] = response.resources.items;
        if (response.resources.items.length > 0) {
          this.fullListSubTotal = 0;
          response.resources.items.forEach(datas => {
            this.fullListSubTotal += datas.subTotal;
          });
        }
        if (response.resources.requisitionRequests.length > 0) {
          this.requestListSubTotal = 0;
          response.resources.requisitionRequests.forEach(requests => {
            this.requestListSubTotal += requests.subTotal;
          });
        }
        if (this.fullListInterbranchRequisitionModel['stockOrderIds'] && this.fullListInterbranchRequisitionModel['stockOrderIds'].indexOf(',') > 0) {
          this.selectedOptions = this.fullListInterbranchRequisitionModel['stockOrderIds'].split(',');
        } else if (this.fullListInterbranchRequisitionModel['stockOrderIds']) {
          this.selectedOptions = [this.fullListInterbranchRequisitionModel['stockOrderIds']];
        }
        if (this.fullListInterbranchRequisitionModel['supplierId'] && this.fullListInterbranchRequisitionModel['supplierId'].indexOf(',') > 0) {
          this.selectSupplierOptions = this.fullListInterbranchRequisitionModel['supplierId'].split(',');
        } else if (this.fullListInterbranchRequisitionModel['supplierId']) {
          this.selectSupplierOptions = this.fullListInterbranchRequisitionModel['supplierId'];
        }
        this.requisitionCreationForm.get('stockOrderIds').setValue(this.selectedOptions);
        this.requisitionCreationForm.get('priorityId').setValue(this.fullListInterbranchRequisitionModel['priorityId']);
        this.createRequisitionDataTable(this.fullListInterbranchRequisitionModel['items'], true);
        if (Object.keys(this.fullListInterbranchRequisitionModel['interBranchTransfers']).length > 0) {
          this.selectedTabIndex = 1;
          this.tabGroup._tabs['_results'][1].disabled = false;
        } else {
          this.selectedTabIndex = 2;
          this.tabGroup._tabs['_results'][1].disabled = false;
        }
        this.tabGroup._tabs['_results'][2].disabled = Object.keys(this.fullListInterbranchRequisitionModel['requisitionRequests']).length > 0 ? false : true;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  deleteRequisition() {

    const dialogRemoveStockCode = this.dialog.open(RequisitionCreationModalComponent, {
      width: '450px',
      data: {
        message: `Are you sure you want to<br />remove the requisition id: ${this.fullListInterbranchRequisitionModel['requisitionNumber']} ?`,
        closeFlag: true,
        buttons: {
          cancel: 'No',
          create: 'Yes'
        }
      }, disableClose: true
    });
    dialogRemoveStockCode.afterClosed().subscribe(result => {
      if (!result) return;
      this.rxjsService.setFormChangeDetectionProperty(true);
      const options = {
        body: {
          requisitionId: this.requisitionCreationForm.get('requisitionId').value,
          modifiedUserId: this.loggedUser.userId
        }
      };
      this.crudService.deleteByParams(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.REQUISITION_LIST,
        options).subscribe((response) => {
          if (response.isSuccess && response.statusCode === 200) {
            this.navigateToList();
          }
        })
      this.rxjsService.setDialogOpenProperty(false);
    });
  }

  deleteStockNumbersBackup(stockId, stockOrderIds, control, index?) {
    // Delete pop up
    const dialogRemoveStockCode = this.dialog.open(RequisitionCreationModalComponent, {
      width: '450px',
      data: {
        message: `Are you sure you want to<br />remove the stock code: ${control.get('stockCode').value} ?`,
        closeFlag: true,
        buttons: {
          cancel: 'No',
          create: 'Yes'
        }
      }, disableClose: true
    });

    dialogRemoveStockCode.afterClosed().subscribe(result => {

      if (!result) return;
      //
      if (!(control.get('requisitionIdForDelete').value)) {
        // Object.keys(this.fullListInterbranchRequisitionModel).length < 1 &&
        let subtotal = this.stockItemsFormArray.controls[index].get('subTotal').value;
        this.fullListSubTotal = this.fullListSubTotal - subtotal;
        this.stockItemsFormArray.removeAt(index);
        return;
      }
      //
      let data = Object.assign({},
        this.requisitionCreationForm.get('requisitionId').value == null ? null : { requisitionId: this.requisitionCreationForm.get('requisitionId').value },
        stockId == null ? null : { stockId: stockId },
        stockOrderIds == null ? null : { stockOrderIds: stockOrderIds },
        this.loggedUser.userId == null ? null : { modifiedUserId: this.loggedUser.userId }
      );
      const options = {
        body: data
      };
      this.rxjsService.setFormChangeDetectionProperty(true);
      this.stockItemsFormArray.removeAt(index);
      // this.crudService.deleteByParams(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.ADD_REQUISITION_ITEM,
      //   options).subscribe((response) => {
      //     if (response.isSuccess && response.statusCode === 200) {
      //       let subtotal = this.stockItemsFormArray.controls[index].get('subTotal').value;
      //       this.fullListSubTotal = this.fullListSubTotal - subtotal;
      //       this.stockItemsFormArray.removeAt(index);
      //       this.fullListInterbranchRequisitionModel['interBranchTransfers'].forEach((element,i) => {
      //         // element.itemId = element.itemId ? element.itemId : element.ItemId;
      //          let filterIndex = element?.interBranchStockDetails.find(x=> (x.itemId ==  stockId || x.ItemId ==  stockId));

      //          if(filterIndex >=0) {
      //            element?.interBranchStockDetails?.splice(filterIndex,1);
      //            if(element?.interBranchStockDetails?.length ==0)
      //               this.fullListInterbranchRequisitionModel['interBranchTransfers'].splice(i,1);
      //          }


      //        });
      //     }
      //   })
      this.rxjsService.setDialogOpenProperty(false);
    });
  }
  deleteStockNumbers(stockId, stockOrderIds, control, index?) {
    this.isDeletePopup = true;
    this.stockId = stockId;
    this.deleteIndex = index;
    this.control = control
    this.stockOrderIds = stockOrderIds;
    // let arr = [];
    // this.fullListInterbranchRequisitionModel['interBranchTransfers'].forEach((element,i) => {
    //   element.itemId = element.itemId ? element.itemId : element.ItemId;
    //   let filterIndex = element?.interBranchStockDetails.find(x=> x.itemId ==  element.itemId);
    //   element?.interBranchStockDetails.splice(filterIndex,1);
    //   if (element.itemId != stockId)
    //     arr.push(element);
    // });

  }
  deleteClose() {
    this.isDeletePopup = false;
  }
  deleteStockCode() {
    let value = this.stockItemsFormArray.value[this.deleteIndex];
    this.stockItemsFormArray.removeAt(this.deleteIndex);
    let ind = this.stockCodes?.findIndex(x => x.stockCode == value.stockCode);
    this.stockCodes?.splice(ind, 1);
    this.isDeletePopup = false;
    this.snackbarService.openSnackbar("Deleted stock code - " + value.stockCode + " Sucessfully!", ResponseMessageTypes.SUCCESS);
    this.fullListAllSubTotal();
  }
  deleteStockCodeDummy() {
    this.isStockChanged = true;
    if (!(this.control.get('requisitionIdForDelete').value)) {
      let stockCode = this.stockItemsFormArray.controls[this.deleteIndex].get('stockCode').value;
      let subtotal = this.stockItemsFormArray.controls[this.deleteIndex].get('subTotal').value;
      this.fullListSubTotal = this.fullListSubTotal - subtotal;
      this.stockItemsFormArray.removeAt(this.deleteIndex);
      let filterIndex = this.stockCodeAndDescriptionList.findIndex(x => x.stockCode == stockCode);
      if (filterIndex)
        this.stockCodeAndDescriptionList.splice(filterIndex, 1);

      this.isDeletePopup = false;
      return;
    }
    let data = Object.assign({},
      this.requisitionCreationForm.get('requisitionId').value == null ? null : { requisitionId: this.requisitionCreationForm.get('requisitionId').value },
      this.stockId == null ? null : { stockId: this.stockId },
      this.stockOrderIds == null ? null : { stockOrderIds: this.stockOrderIds },
      this.loggedUser.userId == null ? null : { modifiedUserId: this.loggedUser.userId }
    );
    const options = {
      body: data
    };
    this.rxjsService.setFormChangeDetectionProperty(true);
    // this.crudService.deleteByParams(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.ADD_REQUISITION_ITEM,
    //   options).subscribe((response) => {

    // if (response.isSuccess && response.statusCode === 200) {
    this.isDeletePopup = false;
    let subtotal = this.stockItemsFormArray?.controls[this.deleteIndex]?.get('subTotal')?.value;
    this.fullListSubTotal = this.fullListSubTotal - subtotal;
    this.stockItemsFormArray.removeAt(this.deleteIndex);

    let tempArr = [];
    this.fullListInterbranchRequisitionModel['interBranchTransfers'].forEach((element, i) => {

      let filterIndex = element?.interBranchStockDetails.findIndex(x => (x.itemId == this.stockId || x.ItemId == this.stockId));
      if (filterIndex >= 0) {
        element?.interBranchStockDetails?.splice(filterIndex, 1);

        if (element?.interBranchStockDetails?.length > 0) {
          let qty = 0;
          element?.interBranchStockDetails.forEach(element => {
            qty = parseInt(element.ibtOrderQty) + qty;
          });
          this.fullListInterbranchRequisitionModel['interBranchTransfers'][i].ibtOrderQty = qty;
          tempArr.push(element);
        }
      } else {
        tempArr.push(element);
      }

    });
    this.fullListInterbranchRequisitionModel['interBranchTransfers'] = tempArr;

    // }
    // })
    this.rxjsService.setDialogOpenProperty(false);
  }
  navigateToList() {
    if (this.requestType == 'inventory-task-list') {
      this.router.navigate(['my-tasks/inventory-task-list']);
    }
    else {
      this.router.navigate(['/inventory', 'requisitions', 'stock-orders']);
    }
  }
  cancelList() {
    this.router.navigate(['/inventory', 'requisitions', 'stock-orders']);
  }
  navigateToViewPage() {
    this.router.navigate(['/inventory', 'requisitions', 'stock-orders', 'requisition-view'], {
      queryParams: {
        requisitionId: this.requisitionId,
        userId: this.loggedUser.userId,
        type: 'requisition-list',
        toValue: this.toValue ? this.toValue : 0,
        referenceId: this.referenceId
      }, skipLocationChange: true
    });
  }

  showCancelRequisition: boolean = false;
  showReasonRequest: boolean = false;
  requisitionReasons = '';
  requisitionReasonsMsg: boolean = false;

  CancelRequisition() {

    this.showCancelRequisition = true;
    this.showReasonRequest = false;

    // // this.navigateToList();
    // const dialogRemoveStockCode = this.dialog.open(RequisitionCreationModalComponent, {
    //   width: '450px',
    //   data: {
    //     message: `Are you sure you want to<br />cancel the Requisition: ${this.fullListInterbranchRequisitionModel['requisitionNumber']} ?`,
    //     buttons: {
    //       cancel: 'No',
    //       create: 'Yes'
    //     }
    //   }, disableClose: true
    // });
    // dialogRemoveStockCode.afterClosed().subscribe(result => {
    //   if (!result) return;
    //   this.rxjsService.setFormChangeDetectionProperty(true);
    //   const options = {
    //     requisitionId: this.requisitionCreationForm.get('requisitionId').value,
    //     modifiedUserId: this.loggedUser.userId,
    //   };
    //   this.crudService.update(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.REQUISITION_CANCEL,
    //     options).subscribe((response) => {
    //       if (response.isSuccess && response.statusCode === 200) {
    //         this.navigateToList();
    //       }
    //     })
    //   this.rxjsService.setDialogOpenProperty(false);
    // });
  }

  submitCancelOrder() {
    this.requisitionReasonsMsg = false;
    if (this.requisitionReasons == '') {
      this.requisitionReasonsMsg = true;
      return;
    }

    const options = {
      requisitionId: this.requisitionCreationForm.get('requisitionId').value,
      modifiedUserId: this.loggedUser.userId,
      reason: this.requisitionReasons
    };
    this.crudService.update(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.REQUISITION_CANCEL,
      options).subscribe((response) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.navigateToList();
        }
        else {
          this.rxjsService.setGlobalLoaderProperty(false);
          this.snackbarService.openSnackbar(response.message, ResponseMessageTypes.ERROR);
        }
      });
  }
  navigateToDetailedList() {
    this.router.navigate(['/inventory', 'requisitions', 'stock-orders', 'detailed-list'], {
      queryParams: {
        requisitionId: this.requisitionId, view: false, type: this.requestType
      }
    });
  }
  uploadFiles(file) {
    this.isStockChanged = true;
    if (file && file.length == 0)
      return;

    var numberOfFilesUploaded = this.listOfFiles.length;
    if (file.length > this.maxFilesUpload || numberOfFilesUploaded >= +this.maxFilesUpload) {
      this.snackbarService.openSnackbar(`You can upload maximum ${this.maxFilesUpload} files`, ResponseMessageTypes.WARNING);
      return;
    }
    const supportedExtensions = [
      'jpeg', 'jpg', 'png', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx'
    ];

    for (let i = 0; i < file.length; i++) {
      let selectedFile = file[i];
      const path = selectedFile.name.split('.');
      const extension = path[path.length - 1];
      const fileNameCondition = isValidFilename(selectedFile?.name, { supportedExtensions: supportedExtensions, extension: extension }, { fileSize: selectedFile?.size, allowedSize: 100 })?.errorMsg;
      if (fileNameCondition) {
        return this.snackbarService.openSnackbar(fileNameCondition);
      }
      let filename = this.fileList.find(x => x.name === selectedFile.name);
      if (filename == undefined) {
        this.fileList.push(selectedFile);
        this.listOfFiles.push({ id: null, name: selectedFile.name });
        this.myFileInputField.nativeElement.value = null;
      }

    }
  }
  removeSelectedFile(index: number, id: string) {
    this.isStockChanged = true;
    // Delete the item from fileNames list
    this.listOfFiles.splice(index, 1);
    // delete file from FileList
    this.fileList.splice(index, 1);
    // let id = this.listOfFiles[index]
    if (id) {
      let indexRemove = this.supplierDocuments.map(function (item: any) {
        return item.requisitionSupplierDocumentId
      }).indexOf(id);
      this.supplierDocuments.splice(indexRemove, 1);
    }
    this.rxjsService.setFormChangeDetectionProperty(true);
  }
  download(path: string) {
    if (path) return fileUrlDownload(path, path, false, this.crudService, this.rxjsService);
  }
  toggle() {
    this.isToggle = !this.isToggle;
  }

}

